<template>
	<div class="incenters">
		<div style="">
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" :useAutoOptional="false" :optional="!rowboo" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.enabled" backgroundColor="#FFF" :title="downTitle" fontSize="14px"
				@btnclick="deactivate" :src="downImg">
			</Commonbtn>
			<Commondown v-if="qx.setting" backgroundColor="#FFF" color="#E71D43" fontSize="14px" :datalist="downlist"
				@downs="downs"></Commondown>
			<Commondown backgroundColor="#FFF" color="#E71D43" fontSize="14px" :datalist="LicenseRList"
				@downs="LicenseRLClick" types="3" titles="证照相关"></Commondown>
			<a class="Dowload" style="" @click="CityDowload">下载省市区信息列表</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable @onRowClick="onRowClick" width="1000px" colnum=22 :tableData="tableData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<DialogFrom width="1000px" :title="licenceTitle" :OKASCAN="false" :dialogVisible="LicenseRLookdialogVisibles"
			@cancel="LicenseRLookcancel" @dialogOK="LicenseRLookdialogOK">
			<div class="LicenseRfrom" v-if="lflag">
				<div v-if="Tobereviewed">
					<Commonbtn backgroundColor="#FFF" title="全部审核" margin="0px 20px 20px 0px" fontSize="14px"
						@btnclick="AllReview" :src="require('@/assets/icon/shen.png')">
					</Commonbtn>
					<!-- v-if="license != null" -->
					<Commonbtn backgroundColor="#FFF" v-if="license != null" title="营业执照驳回" margin="0px 20px 20px 10px"
						fontSize="14px" @btnclick="businessLicense" :src="require('@/assets/icon/reject.png')">
					</Commonbtn>
					<!--  v-if="permission != null" -->
					<Commonbtn backgroundColor="#FFF" v-if="permission != null" title="医疗器械经营许可证驳回"
						margin="0px 20px 20px 10px" fontSize="14px" @btnclick="medicalEquipment"
						:src="require('@/assets/icon/reject.png')">
					</Commonbtn>
					<!-- v-if="record != null" -->
					<Commonbtn backgroundColor="#FFF" v-if="record != null" title="第二类医疗器械备案凭证驳回"
						margin="0px 20px 20px 10px" fontSize="14px" @btnclick="CLLMDFCR"
						:src="require('@/assets/icon/reject.png')">
					</Commonbtn>
				</div>
				<div class="type">
					<div class="type-top">
						<div class="type-top-left"></div>
						营业执照
					</div>
					<div class="type-text" v-if="license != null">
						<div class="CodeText">
							备案号：<span> {{ license.BLCompanyName }}</span>
						</div>
						<div class="CodeText">
							企业名称：<span>{{ license.BLCompanyName }}</span>
						</div>
						<div class="CodeText">
							经营方式： <span>{{ license.BLBusinessMode }}</span>
						</div>
						<div class="CodeText">
							住所： <span>{{ license.BLAddress }}</span>
						</div>
						<div class="CodeText">
							经营场所： <span>{{ license.BLBusinessAddr }}</span>
						</div>
						<div class="CodeText">
							库房地址： <span>{{ license.BLWarehouseAddr }}</span>
						</div>
						<div class="CodeText">
							法定代表人： <span>{{ license.BLLegalRepresentative }}</span>
						</div>
						<div class="CodeText">
							企业负责人： <span>{{ license.BLCEO }}</span>
						</div>
						<div class="CodeText">
							二类经营范围： <span>{{ license.BLSecInvSort }}</span>
						</div>
						<div class="CodeText">
							备案日期： <span>{{ license.BLFilingDate }}</span>
						</div>
						<div class="CodeText">
							提交时间： <span>{{ license.CreateTime }}</span>
						</div>
						<div class="CodeText">
							审核时间： <span>{{ license.VerifyTime }}</span>
						</div>
						<div class="CodeText">
							驳回时间： <span>{{ license.RejectTime }}</span>
						</div>
						<div class="CodeText">
							驳回原因： <span>{{ license.RejectReason }}</span>
						</div>
						<div class="CodeText">
							营业执照： <span><img :src="license.BLPhotoURL"></span>
						</div>
					</div>
				</div>

				<div class="type">
					<div class="type-top">
						<div class="type-top-left"></div>
						医疗器械经营许可证
					</div>
					<div class="type-text" v-if="permission != null">
						<div class="CodeText">
							许可证编号： <span>{{ permission.BusLicenceCode }}</span>
						</div>
						<div class="CodeText">
							企业名称： <span>{{ permission.BusCompanyName }}</span>
						</div>
						<div class="CodeText">
							经营方式： <span>{{ permission.BusBusinessMode }}</span>
						</div>
						<div class="CodeText">
							住所： <span>{{ permission.BusAddress }}</span>
						</div>
						<div class="CodeText">
							经营场所： <span>{{ permission.BusBusinessAddr }}</span>
						</div>
						<div class="CodeText">
							库房地址： <span>{{ permission.BusWarehouseAddr }}</span>
						</div>
						<div class="CodeText">
							注册地址： <span>{{ permission.BusRegisterAddr }}</span>
						</div>
						<div class="CodeText">
							法定代表人： <span>{{ permission.BusLegalRepresentative }}</span>
						</div>
						<div class="CodeText">
							企业负责人： <span>{{ permission.BusCEO }}</span>
						</div>
						<div class="CodeText">
							经营范围： <span>{{ permission.BusThirdInvSort }}</span>
						</div>
						<div class="CodeText">
							发证日期： <span>{{ permission.BusIssueDate }}</span>
						</div>
						<div class="CodeText">
							起始日期： <span>{{ permission.BusStartDate }}</span>
						</div>
						<div class="CodeText">
							失效日期： <span>{{ permission.BusEndDate }}</span>
						</div>
						<div class="CodeText">
							提交时间： <span>{{ permission.CreateTime }}</span>
						</div>
						<div class="CodeText">
							审核时间： <span>{{ permission.VerifyTime }}</span>
						</div>
						<div class="CodeText">
							驳回时间： <span>{{ permission.RejectTime }}</span>
						</div>
						<div class="CodeText">
							图片显示地址： <span><img :src="permission.BusPhotoURL"></span>
						</div>

						<div class="CodeText">
							驳回原因： <span>{{ permission.RejectReason }}</span>
						</div>
					</div>
				</div>

				<div class="type">
					<div class="type-top">
						<div class="type-top-left"></div>
						第二类医疗器械备案凭证
					</div>
					<div class="type-text" v-if="record != null">
						<div class="CodeText">
							备案号： <span>{{ record.BRFilingCode }}</span>
						</div>
						<div class="CodeText">
							企业名称： <span>{{ record.BRCompanyName }}</span>
						</div>
						<div class="CodeText">
							经营方式： <span>{{ record.BRBusinessMode }}</span>
						</div>
						<div class="CodeText">
							住所： <span>{{ record.BRAddress }}</span>
						</div>
						<div class="CodeText">
							经营场所： <span>{{ record.BRBusinessAddr }}</span>
						</div>
						<div class="CodeText">
							库房地址： <span>{{ record.BRWarehouseAddr }}</span>
						</div>
						<div class="CodeText">
							法定代表人： <span>{{ record.BRLegalRepresentative }}</span>
						</div>
						<div class="CodeText">
							企业负责人： <span>{{ record.BRCEO }}</span>
						</div>
						<div class="CodeText">
							二类经营范围： <span>{{ record.BRSecInvSort }}</span>
						</div>
						<div class="CodeText">
							备案日期： <span>{{ record.BRFilingDate }}</span>
						</div>
						<div class="CodeText">
							提交时间： <span>{{ record.CreateTime }}</span>
						</div>
						<div class="CodeText">
							审核时间： <span>{{ record.VerifyTime }}</span>
						</div>
						<div class="CodeText">
							驳回时间：<span>{{ record.RejectTime }}</span>
						</div>
						<div class="CodeText">
							图片显示地址： <span><img :src="record.BRPhotoURL"></span>
						</div>
						<div class="CodeText">
							驳回原因： <span>{{ record.RejectReason }}</span>
						</div>
					</div>
				</div>

			</div>
		</DialogFrom>
		<DialogFrom width="640px" title="营业执照驳回原因" :dialogVisible="licenseBHdialogVisibles" @cancel="licenseBHcancel"
			@dialogOK="licenseBHdialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonLicense">
			</el-input>
		</DialogFrom>

		<DialogFrom width="640px" title="医疗器械经营许可证驳回原因" :dialogVisible="permissionBHdialogVisibles"
			@cancel="permissionBHcancel" @dialogOK="permissionBHdialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonPermission">
			</el-input>
		</DialogFrom>

		<DialogFrom width="640px" title="第二类医疗器械备案凭证驳回原因" :dialogVisible="recordBHdialogVisibles"
			@cancel="recordBHcancel" @dialogOK="recordBHdialogOK">
			<el-input type="textarea" placeholder="请输入内容" v-model="RejectReasonRecord">
			</el-input>
		</DialogFrom>

		<DialogFrom width="1000px" title="驳回列表" :dialogVisible="rejectdialogVisibles" @cancel="rejectcancel"
			@dialogOK="rejectdialogOK">
			<Commontable @onRowClick="rejectdonRowClick" width="1000px" colnum=7 :tableData="rejectTable"
				:headerData="rejectHeaderData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="rejecthandleCurrentChange" @handleSizeChange="rejecthandleSizeChange"
					:total="rejecttotal"></Pagination>
			</div>
			<div class="detailedCss">{{ detailsTitle }}明细</div>
			<div class="type" v-if="BLdetailsTableData != null">
				<div class="type-top">
					<div class="type-top-left"></div>
					营业执照
				</div>
				<div class="type-text">
					<div class="CodeText">
						备案号：<span> {{ BLdetailsTableData.BLCompanyName }}</span>
					</div>
					<div class="CodeText">
						企业名称：<span>{{ BLdetailsTableData.BLCompanyName }}</span>
					</div>
					<div class="CodeText">
						经营方式： <span>{{ BLdetailsTableData.BLBusinessMode }}</span>
					</div>
					<div class="CodeText">
						住所： <span>{{ BLdetailsTableData.BLAddress }}</span>
					</div>
					<div class="CodeText">
						经营场所： <span>{{ BLdetailsTableData.BLBusinessAddr }}</span>
					</div>
					<div class="CodeText">
						库房地址： <span>{{ BLdetailsTableData.BLWarehouseAddr }}</span>
					</div>
					<div class="CodeText">
						法定代表人： <span>{{ BLdetailsTableData.BLLegalRepresentative }}</span>
					</div>
					<div class="CodeText">
						企业负责人： <span>{{ BLdetailsTableData.BLCEO }}</span>
					</div>
					<div class="CodeText">
						二类经营范围： <span>{{ BLdetailsTableData.BLSecInvSort }}</span>
					</div>
					<div class="CodeText">
						备案日期： <span>{{ BLdetailsTableData.BLFilingDate }}</span>
					</div>
					<div class="CodeText">
						提交时间： <span>{{ BLdetailsTableData.CreateTime }}</span>
					</div>
					<div class="CodeText">
						审核时间： <span>{{ BLdetailsTableData.VerifyTime }}</span>
					</div>
					<div class="CodeText">
						驳回时间： <span>{{ BLdetailsTableData.RejectTime }}</span>
					</div>
					<div class="CodeText">
						驳回原因： <span>{{ BLdetailsTableData.RejectReason }}</span>
					</div>
					<div class="CodeText">
						营业执照：
						<div class="imgBox" @mouseenter="ImgMouseover" @mouseleave="ImgMouseout">
							<!-- ${ config.http_URL } + -->
							<img :src="`${BLdetailsTableData.BLPhotoURL}`">
						</div>
						<div class="imgTop" v-show="imgflag"><img
								src="../../../../assets/channel/firstbusiness/phontsD.png" alt="" class="imgPhoto"
								@click="imgShowClick(BLdetailsTableData.BLPhotoURL)"></div>
					</div>
				</div>
			</div>

			<div class="type" v-if="BusdetailsTableData != null">
				<div class="type-top">
					<div class="type-top-left"></div>
					医疗器械经营许可证
				</div>
				<div class="type-text">
					<div class="CodeText">
						许可证编号： <span>{{ BusdetailsTableData.BusLicenceCode }}</span>
					</div>
					<div class="CodeText">
						企业名称： <span>{{ BusdetailsTableData.BusCompanyName }}</span>
					</div>
					<div class="CodeText">
						经营方式： <span>{{ BusdetailsTableData.BusBusinessMode }}</span>
					</div>
					<div class="CodeText">
						住所： <span>{{ BusdetailsTableData.BusAddress }}</span>
					</div>
					<div class="CodeText">
						经营场所： <span>{{ BusdetailsTableData.BusBusinessAddr }}</span>
					</div>
					<div class="CodeText">
						库房地址： <span>{{ BusdetailsTableData.BusWarehouseAddr }}</span>
					</div>
					<div class="CodeText">
						注册地址： <span>{{ BusdetailsTableData.BusRegisterAddr }}</span>
					</div>
					<div class="CodeText">
						法定代表人： <span>{{ BusdetailsTableData.BusLegalRepresentative }}</span>
					</div>
					<div class="CodeText">
						企业负责人： <span>{{ BusdetailsTableData.BusCEO }}</span>
					</div>
					<div class="CodeText">
						经营范围： <span>{{ BusdetailsTableData.BusThirdInvSort }}</span>
					</div>
					<div class="CodeText">
						发证日期： <span>{{ BusdetailsTableData.BusIssueDate }}</span>
					</div>
					<div class="CodeText">
						起始日期： <span>{{ BusdetailsTableData.BusStartDate }}</span>
					</div>
					<div class="CodeText">
						失效日期： <span>{{ BusdetailsTableData.BusEndDate }}</span>
					</div>
					<div class="CodeText">
						提交时间： <span>{{ BusdetailsTableData.CreateTime }}</span>
					</div>
					<div class="CodeText">
						审核时间： <span>{{ BusdetailsTableData.VerifyTime }}</span>
					</div>
					<div class="CodeText">
						驳回时间： <span>{{ BusdetailsTableData.RejectTime }}</span>
					</div>
					<div class="CodeText">
						图片显示地址： <span><img :src="BusdetailsTableData.BusPhotoURL"></span>
					</div>

					<div class="CodeText">
						驳回原因： <span>{{ BusdetailsTableData.RejectReason }}</span>
					</div>
				</div>
			</div>

			<div class="type" v-if="RedetailsTableData != null">
				<div class="type-top">
					<div class="type-top-left"></div>
					第二类医疗器械备案凭证
				</div>
				<div class="type-text">
					<div class="CodeText">
						备案号： <span>{{ RedetailsTableData.BRFilingCode }}</span>
					</div>
					<div class="CodeText">
						企业名称： <span>{{ RedetailsTableData.BRCompanyName }}</span>
					</div>
					<div class="CodeText">
						经营方式： <span>{{ RedetailsTableData.BRBusinessMode }}</span>
					</div>
					<div class="CodeText">
						住所： <span>{{ RedetailsTableData.BRAddress }}</span>
					</div>
					<div class="CodeText">
						经营场所： <span>{{ RedetailsTableData.BRBusinessAddr }}</span>
					</div>
					<div class="CodeText">
						库房地址： <span>{{ RedetailsTableData.BRWarehouseAddr }}</span>
					</div>
					<div class="CodeText">
						法定代表人： <span>{{ RedetailsTableData.BRLegalRepresentative }}</span>
					</div>
					<div class="CodeText">
						企业负责人： <span>{{ RedetailsTableData.BRCEO }}</span>
					</div>
					<div class="CodeText">
						二类经营范围： <span>{{ RedetailsTableData.BRSecInvSort }}</span>
					</div>
					<div class="CodeText">
						备案日期： <span>{{ RedetailsTableData.BRFilingDate }}</span>
					</div>
					<div class="CodeText">
						提交时间： <span>{{ RedetailsTableData.CreateTime }}</span>
					</div>
					<div class="CodeText">
						审核时间： <span>{{ RedetailsTableData.VerifyTime }}</span>
					</div>
					<div class="CodeText">
						驳回时间：<span>{{ RedetailsTableData.RejectTime }}</span>
					</div>
					<div class="CodeText">
						图片显示地址： <span><img :src="RedetailsTableData.BRPhotoURL"></span>
					</div>
					<div class="CodeText">
						驳回原因： <span>{{ RedetailsTableData.RejectReason }}</span>
					</div>
				</div>
			</div>
		</DialogFrom>

		<DialogFrom width="1000px" title="新增一级经销商档案" :dialogVisible="dialogVisibles" @cancel="cancel"
			@dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item , index) of fromdataadd">
					<Commondropdownlist :widths="item.widths" :radio="item.radio" :options="item.options" :key="index"
						ref="priAdd" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
						:color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
						:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
						:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"
						:checkboxdata="item.checkboxdata" :disabled="item.disabled">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>

		<DialogFrom width="1000px" title="修改一级经销商档案" :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<div class="from">
				<template v-for="(item , index) of fromdataedit">
					<Commondropdownlist ref="priupdate" :radio="item.radio" :widths="item.widths"
						:options="item.options" :key="index" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
						:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min"
						:max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>

		<DialogFrom width="1000px" title="选中的经销商名称" :dialogVisible="dialogVisiblesU8" @cancel="cancelU8"
			@dialogOK="dialogOKeditU8">
			<div class="from">
				<template v-for="(item , index) of fromdataU8">
					<Commondropdownlist ref="U8primRefs" :key="index" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1"
						:radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min"
						:max="item.max">
					</Commondropdownlist>
				</template>
			</div>
			<div style="width: 952px;height: 1px;background-color: #F0F0F0;margin-top: 30px;"></div>
			<div style="width: 952px;">
				<Commonbtn backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="U8add"
					:src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>
				<Commonbtn backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="U8del"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
				<div style="width: 100%;">
					<Commontable @handleSelectionChange="handleSelectionChange" width="1000px" colnum=5
						:tableData="tableU8Data" :headerData="headerData1" height="100%">
					</Commontable>
				</div>
			</div>
		</DialogFrom>

		<DialogFrom width="640px" title="导入U8配置" :dialogVisible="dialogVisiblesU8d" @cancel="cancelU8d"
			@dialogOK="dialogOKeditU8d">
			<div style="width: 952px;">
				<CommonbtnUpLoad style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF" title="U8配置导入"
					fontSize="14px" @getFile="U8Import" types="file" :src="require('@/assets/icon/icon-drjys.png')">
				</CommonbtnUpLoad>
				<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
					@click="u8DowloadImporttemplate">U8配置导入模版下载</a>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-template;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条档案吗？</span>
		</Dialog>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-template;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停启用这条档案吗？</span>
		</Dialog>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import rejectHeaderData from '../tableData/rejectHeaderData'
	import {
		BaOrganizationU8MatchList,
		BaOrganizationAddU8Match,
		BaOrganizationDeleteU8Match,
		BaOrganizationDownloadU8MatchTemplet,
		BaOrganizationImportU8Match,
		BaOrganizationList,
		BaOrganizationInfo,
		BaOrganizationAdd,
		BaOrganizationEdit,
		BaOrganizationDelete,
		BaOrganizationSetActive,
		InventoryClassList,
		CustomeDownloadAreaListr,
		CusType,
		LicenseGetAllLicense,
		LicenseRejectBusinessLicense,
		LicenseRejectBusinessPermission,
		LicenseRejectBusinessRecord,
		LicenseVerifyLicense,
		LicenseGetRejectLicense,
		LicenseGetBusinessLicense,
		LicenseGetBusinessPermission,
		LicenseGetBusinessRecord
	} from '@/api/home'
	export default {
		components: {
			Commonbtn,
			Commondown,
			Commontable,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonbtnUpLoad
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			},
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				dialogVisiblesU8: false,
				dialogVisiblesU8d: false,
				LicenseRLookdialogVisibles: false,
				licenseBHdialogVisibles: false,
				permissionBHdialogVisibles: false,
				rejectdialogVisibles: false,
				recordBHdialogVisibles: false,
				rightboo: false,
				dwonleft: false,
				rowboo: false,
				lflag: false,
				dialogVisiblesdrjg: false,
				CusTypestate: -1,
				ptype: '',
				companyID: '',
				companyName: '',
				parentId: '',
				CusCode: "",
				CompanyID: "",
				RejectReasonPermission: "",
				RejectReasonLicense: '',
				RejectReasonRecord: '',
				detailsTitle: '',
				getID: '',
				Tobereviewed: false,
				rejecttotal: null,
				BLdetailsTableData: null,
				BusdetailsTableData: null,
				RedetailsTableData: null,
				licenceTitle: '查看有效证照',
				title: "",
				downTitle: "启用",
				downImg: require('@/assets/icon/qy.png'),
				cusGrade: 0,
				actived: 0,
				fromdataadd: [],
				fromdataedit: [],
				U8IDsData: [],
				qus: [],
				tableU8Data: [],
				tableDatadrjg: [],
				rejectHeaderData: [],
				rejectTable: [],
				from: {
					companyID: '',
					companyName: '',
					parentId: '',
					remark: '',
					grade: 0,
					actived: 0,
					licenseNo: '',
					licenseVDate: '',
					licenseMDate: '',
					voucherNo: '',
					voucherMDate: '',
					voucherVDate: '',
					companyInCharge: '',
					businessAddress: '',
					companyInLaw: '',
					warehouseAddress: '',
					autoOutToIn: 0,
					MarkupRate: 1.04,
					Mobile: "",
					Email: "",
					U8AccId: ""
				},
				fromdataU8: [{
					inputdata: '',
					title: 'U8账套',
					fontSize: '14px',
					color: '#333333',
					placeholder: '请输入',
					types: 'text',
					inputtype: 'input',
					width: '210px',
					lablewith: '55px'
				}, {
					inputdata: '',
					title: 'U8编号',
					fontSize: '14px',
					color: '#333333',
					placeholder: '请输入',
					types: 'text',
					inputtype: 'input',
					width: '210px',
				}, ],
				tableData1: [{}],
				headerData1: [{
						prop: 'AccID',
						label: 'U8账套',
						columnwidth: 400,
					},
					{
						prop: 'U8Code',
						label: 'U8编号',
						columnwidth: 522
					},
				],
				downlist: [{
						title: 'U8配置'
					},
					{
						title: '导入U8配置'
					},
				],
				LicenseRList: [{
					title: '查看有效证照'
				}, ],
				LicenseRLists: [{
						title: '查看有效证照'
					},
					{
						title: '查看待审核证照'
					},
					{
						title: '查看历史驳回证照'
					}
				],
				UnVerifyLicenseCount: null, //待审核证照数量
				ValidLicenseCount: null, //有效证照数量
				RejectLicenseCount: null, //被驳回证照数量
				license: null, //营业执照部分
				permission: null, //医疗器械经营许可证部分
				record: null, //第二类医疗器械备案凭证部分
				status: null,
				enabled: 1,
				RejectReason: "",
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false,
					License: false, //证照
				},

			}
		},
		mounted() {
			this.rejectHeaderData = JSON.parse(JSON.stringify(rejectHeaderData))
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.CusType()
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 33) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 37) {
								this.qus = items.Nodes
							}
						})
					}
					// console.log(this.qus, 'this.qus');
				})
				//console.log(this.qus);
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'setting') {
							this.qx.setting = true
						} else if (item.NodeName == 'License') {
							this.qx.License = true
							this.LicenseRList = this.LicenseRLists
						}
					})
				}
			},
			// 判断一二级经销商
			async CusType() {
				let {
					code,
					data
				} = await CusType({})
				if (code == 0) {
					if (data.CusType == "平台") {
						this.CusTypestate = 1
					}
					if (data.CusType == "经销商") {
						this.CusTypestate = 0
					}
				}
			},
			// U8配置列表
			async BaOrganizationU8MatchList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await BaOrganizationU8MatchList({
					code: this.CompanyID
					// code: this.CompanyID //admin测试参数
				})
				if (code == 0) {
					this.tableU8Data = data.data
					loading.close();
				}
				loading.close();
			},
			// 新增
			async baOrganizationAddU8Match() {
				if (this.$refs.U8primRefs[0].modelvalue == "") {
					this.$message({
						type: "warning",
						message: "U8账套不能为空"
					})
					return false
				}
				if (this.$refs.U8primRefs[1].modelvalue == "") {
					this.$message({
						type: "warning",
						message: "U8编号不能为空"
					})
					return false
				}
				let {
					code,
					message
				} = await BaOrganizationAddU8Match({
					Code: this.CusTypestate == 0 ? this.CusCode : this.CompanyID,
					// Code: this.CompanyID, //admin测试参数
					AccID: this.$refs.U8primRefs[0].modelvalue,
					U8Code: this.$refs.U8primRefs[1].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "新增成功"
					})
					this.$refs.U8primRefs.map((item, index) => {
						item.modelvalue = ""
					})
					this.BaOrganizationU8MatchList()
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			// U8配置新增
			U8add() {
				this.baOrganizationAddU8Match()
			},
			// 删除
			async bBaOrganizationDeleteU8Match() {
				let arrIDs = []
				this.U8IDsData.map((item, index) => {
					arrIDs.push(item.ID)
				})
				let {
					code,
					message
				} = await BaOrganizationDeleteU8Match({
					IDs: arrIDs
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					})
					this.BaOrganizationU8MatchList()
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
			},
			// U8配置删除
			U8del() {
				this.bBaOrganizationDeleteU8Match()
			},
			async baOrganizationList() {
				let {
					data,
					code
				} = await BaOrganizationList({
					onlyParents: 1
				})
				//console.log(code, data)
				if (code == 0) {
					let arr = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CompanyID,
							value: item.CompanyName
						}
						arr.push(obj)
					})
					this.fromdataadd[2].options = arr
					this.fromdataedit[2].options = arr
					// 默认选中第一个
					try {
						this.$refs.priAdd[2].modelvalue = data.data[0].CompanyID
						// this.$refs.priupdate[2].modelvalue = data.data[0].CompanyID
					} catch (error) {

					}
				}
			},
			async baOrganizationDownloadU8MatchTemplet() {
				let {
					data,
					code,
					message
				} = await BaOrganizationDownloadU8MatchTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 下载U8导入模板
			u8DowloadImporttemplate() {
				this.baOrganizationDownloadU8MatchTemplet()
			},
			// 导入
			async baOrganizationImportU8Match(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await BaOrganizationImportU8Match(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			U8Import(file) {
				this.baOrganizationImportU8Match(file)
			},
			async inventoryClassList() {
				let {
					data,
					code
				} = await InventoryClassList({
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				//console.log(code, data)
				if (code == 0) {
					// let arr = []
					// data.data.map((item, index) => {
					//   let obj = {
					//     key: index + 1,
					//     value: item.InvClassName
					//   }
					//   arr.push(obj)
					// })
					// this.fromdataadd[2].options = arr
					// this.fromdataedit[2].options = arr
				}
			},
			// 新增
			async baOrganizationAdd() {
				let {
					code,
					message
				} = await BaOrganizationAdd({
					companyID: this.from.companyID,
					companyName: this.from.companyName,
					parentId: this.from.parentId,
					remark: this.from.remark,
					actived: this.from.actived,
					licenseNo: this.from.licenseNo,
					licenseVDate: this.from.licenseVDate,
					licenseMDate: this.from.licenseMDate,
					voucherNo: this.from.VoucherNo,
					voucherMDate: this.from.voucherMDate,
					voucherVDate: this.from.voucherVDate,
					companyInCharge: this.from.companyInCharge,
					businessAddress: this.from.businessAddress,
					companyInLaw: this.from.companyInLaw,
					warehouseAddress: this.from.warehouseAddress,
					autoOutToIn: this.from.autoOutToIn,
					MarkupRate: this.from.MarkupRate,
					Mobile: this.from.Mobile,
					Email: this.from.Email,
					U8AccId: this.from.U8AccId,
					AbbName: this.from.AbbName,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.rowboo = false
					this.$refs.priAdd.map((item, index) => {
						if (index == 5) {
							item.radio = "1"
						}
						item.modelvalue = ''
					})
					this.dialogVisibles = false
					this.$parent.baOrganizationList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 详情
			async baOrganizationInfo() {
				let {
					code,
					data
				} = await BaOrganizationInfo({
					companyID: this.companyID,
					companyName: this.companyName,
					parentId: this.parentId,
					cusGrade: this.cusGrade,
					actived: this.actived,
				})
				if (code == 0) {

					this.$refs.priupdate[0].modelvalue = data.CompanyID
					this.$refs.priupdate[1].modelvalue = data.CompanyName
					this.$refs.priupdate[2].modelvalue = String(data.ParentId)
					this.$refs.priupdate[3].modelvalue = data.AutoOutToIn + ""

					this.$refs.priupdate[4].modelvalue = data.Remark
					this.$refs.priupdate[5].radios = data.Actived + ""
					this.$refs.priupdate[6].modelvalue = data.CompanyInCharge

					this.$refs.priupdate[7].modelvalue = data.BusinessAddress
					this.$refs.priupdate[8].modelvalue = data.CompanyInLaw
					this.$refs.priupdate[9].modelvalue = data.WarehouseAddress

					this.$refs.priupdate[10].modelvalue = data.LicenseNo
					this.$refs.priupdate[11].modelvalue = data.LicenseVDate
					this.$refs.priupdate[12].modelvalue = data.LicenseMDate

					this.$refs.priupdate[13].modelvalue = data.VoucherNo
					this.$refs.priupdate[14].modelvalue = data.VoucherVDate
					this.$refs.priupdate[15].modelvalue = data.VoucherMDate
					this.$refs.priupdate[16].modelvalue = data.Mobile == null ? "" : data.Mobile
					this.$refs.priupdate[17].modelvalue = data.Email == null ? "" : data.Email

					this.$refs.priupdate[18].modelvalue = data.MarkupRate
					this.$refs.priupdate[19].modelvalue = data.U8AccId
					this.$refs.priupdate[20].modelvalue = data.AbbName
				}
			},
			// 修改
			async baOrganizationEdit(datalist) {
				let {
					code,
					message
				} = await BaOrganizationEdit({
					companyID: datalist[0].modelvalue,
					companyName: datalist[1].modelvalue,
					parentId: datalist[2].modelvalue,
					remark: datalist[4].modelvalue,
					actived: Number(datalist[5].radios),
					licenseNo: datalist[10].modelvalue,
					licenseVDate: datalist[11].modelvalue,
					licenseMDate: datalist[12].modelvalue,
					voucherNo: datalist[13].modelvalue,
					voucherMDate: datalist[15].modelvalue,
					voucherVDate: datalist[14].modelvalue,
					companyInCharge: datalist[6].modelvalue,
					businessAddress: datalist[7].modelvalue,
					companyInLaw: datalist[8].modelvalue,
					warehouseAddress: datalist[9].modelvalue,
					MarkupRate: datalist[18].modelvalue,
					autoOutToIn: Number(datalist[3].modelvalue),
					Mobile: datalist[16].modelvalue,
					Email: datalist[17].modelvalue,
					U8AccId: datalist[19].modelvalue,
					AbbName: datalist[20].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '修改成功'
					});
					this.rowboo = false
					this.dialogVisiblesedit = false
					this.$parent.baOrganizationList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 启用
			async baOrganizationSetActive() {
				let {
					code,
					message
				} = await BaOrganizationSetActive({
					companyID: this.companyID,
					actived: this.downTitle == "启用" ? 1 : 0,
				})
				if (code == 0) {
					if (this.downTitle == "启用") {
						this.$message({
							type: 'success',
							message: '启用成功'
						});
					}
					if (this.downTitle == "停用") {
						this.$message({
							type: 'success',
							message: '停用成功'
						});
					}
					this.rowboo = false
					this.$parent.baOrganizationList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 删除
			async baOrganizationDelete() {
				let {
					code,
					message
				} = await BaOrganizationDelete({
					companyID: this.companyID,
					actived: this.actived,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.rowboo = false
					this.$parent.baOrganizationList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			async customeDownloadAreaListr() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await CustomeDownloadAreaListr({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			CityDowload() {
				this.customeDownloadAreaListr()
			},
			onRowClick(val) {
				this.rowboo = true
				this.companyID = val.CompanyID
				this.companyName = val.CompanyName
				this.parentId = val.CompanyName
				this.cusGrade = val.CusGrade
				this.actived = val.Actived
				this.CusCode = val.CusCode
				this.CompanyID = val.CompanyID
				this.UnVerifyLicenseCount = val.UnVerifyLicenseCount //待审核证照数量
				this.ValidLicenseCount = val.ValidLicenseCount //有效证照数量
				this.RejectLicenseCount = val.RejectLicenseCount //被驳回证照数量
				if (val.Actived == 0) {
					this.downTitle = "启用"
					this.downImg = require('@/assets/icon/qy.png')
				}
				if (val.Actived == 1) {
					this.downTitle = "停用"
					this.downImg = require('@/assets/icon/icon-stop.png')
				}
				//console.log(val, 'val')
			},
			// 驳回列表
			async licenseGetRejectLicense() {
				let {
					code,
					data,
					message
				} = await LicenseGetRejectLicense({
					cusCode: this.companyID,
					cusType: "平台",
					pageSize: this.RejectpageSize,
					pageIndex: this.Rejectpageindex
				})
				if (code == 0) {
					this.rejecttotal = data.Count
					this.rejectTable = data.data
				}
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			adduser() {
				this.dialogVisibles = true
				this.baOrganizationList()
				try {
					this.$refs.priAdd[3].modelvalue = "1"
				} catch (error) {}
			},
			cancel() {
				this.$refs.priAdd.map((item, index) => {
					if (index == 5) {
						item.radio = "1"
					}
					item.modelvalue = ''
				})
				this.dialogVisibles = false
			},
			dialogOK() {
				this.from.companyID = this.$refs.priAdd[0].modelvalue
				this.from.companyName = this.$refs.priAdd[1].modelvalue
				this.from.parentId = this.$refs.priAdd[2].modelvalue
				this.from.autoOutToIn = this.$refs.priAdd[3].modelvalue
				this.from.remark = this.$refs.priAdd[4].modelvalue
				this.from.actived = this.$refs.priAdd[5].radios
				this.from.companyInCharge = this.$refs.priAdd[6].modelvalue
				this.from.businessAddress = this.$refs.priAdd[7].modelvalue
				this.from.companyInLaw = this.$refs.priAdd[8].modelvalue
				this.from.warehouseAddress = this.$refs.priAdd[9].modelvalue
				this.from.licenseNo = this.$refs.priAdd[10].modelvalue
				this.from.licenseVDate = this.$refs.priAdd[11].modelvalue
				this.from.licenseMDate = this.$refs.priAdd[12].modelvalue
				this.from.VoucherNo = this.$refs.priAdd[13].modelvalue
				this.from.voucherMDate = this.$refs.priAdd[14].modelvalue
				this.from.voucherVDate = this.$refs.priAdd[15].modelvalue
				this.from.Mobile = this.$refs.priAdd[16].modelvalue
				this.from.Email = this.$refs.priAdd[17].modelvalue
				this.from.MarkupRate = this.$refs.priAdd[18].modelvalue
				this.from.U8AccId = this.$refs.priAdd[19].modelvalue
				this.from.AbbName = this.$refs.priAdd[20].modelvalue
				this.baOrganizationAdd()

			},
			update() {
				if (this.rowboo == true) {
					// this.inventoryClassList()
					this.baOrganizationInfo()
					this.baOrganizationList()
					this.dialogVisiblesedit = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});

			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				this.baOrganizationEdit(this.$refs.priupdate)

			},
			del() {
				if (this.rowboo == true) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});

			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.baOrganizationDelete()
				this.dialogVisibledel = false
			},
			deactivate() {
				if (this.rowboo == true) {

					this.dialogVisibledeactivate = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要启用的数据！'
				});

			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false
			},
			dialogOKdeactivate() {
				this.baOrganizationSetActive()
				this.dialogVisibledeactivate = false
			},
			downs(index) {
				if (index == 0) {
					if (this.rowboo == true) {
						this.BaOrganizationU8MatchList()
						this.dialogVisiblesU8 = true
						return
					}
					this.$message({
						type: 'error',
						message: '请选择需要配置的数据！'
					});

				}
				if (index == 1) {
					this.dialogVisiblesU8d = true
				}
			},
			// 查看各种状态证照
			async licenseGetAllLicense() {
				let {
					data,
					code
				} = await LicenseGetAllLicense({
					cusCode: this.CompanyID,
					cusType: "平台",
					status: this.status,
					enabled: this.enabled
				})
				if (code == 0) {
					this.lflag = true
					this.license = data.license //营业执照部分
					this.permission = data.permission //医疗器械经营许可证部分
					this.record = data.record //第二类医疗器械备案凭证部分
				}
			},
			LicenseRLClick(index) {
				if (index == 0) {
					// this.UnVerifyLicenseCount = val.UnVerifyLicenseCount //待审核证照数量
					// this.ValidLicenseCount = val.ValidLicenseCount //有效证照数量
					// this.RejectLicenseCount = val.RejectLicenseCount //被驳回证照数量
					if (this.rowboo == true) {
						if (this.ValidLicenseCount > 0) {
							this.LicenseRLookdialogVisibles = true
							this.status = null
							this.enabled = 1
							this.licenseGetAllLicense()
							this.Tobereviewed = false
							return
						}
						this.$message({
							type: "warning",
							message: "没有所查看的有效证照"
						})

						return
					}
					this.$message({
						type: "warning",
						message: "请选择要操作行"
					})

					//console.log(this.UnVerifyLicenseCount, this.ValidLicenseCount, this.RejectLicenseCount);
				}
				if (index == 1) {
					if (this.rowboo == true) {
						if (this.UnVerifyLicenseCount > 0) {
							this.status = 0
							this.enabled = 0
							this.licenceTitle = "审核有效证照"
							this.licenseGetAllLicense()
							this.LicenseRLookdialogVisibles = true
							this.Tobereviewed = true
							return
						}
						this.$message({
							type: "warning",
							message: "没有审核有效证照"
						})
						return
					}
					this.$message({
						type: "warning",
						message: "请选择要操作行"
					})
				}
				if (index == 2) {
					if (this.rowboo == true) {
						if (this.RejectLicenseCount > 0) {
							this.rejectdialogVisibles = true
							this.licenseGetRejectLicense()
							return
						}
						this.$message({
							type: "warning",
							message: "没有驳回相关数据"
						})
						return
					}
					this.$message({
						type: "warning",
						message: "请选择要操作行"
					})

				}
			},
			async licenseRejectBusinessLicense() {
				let {
					code,
					data,
					message
				} = await LicenseRejectBusinessLicense({
					blid: this.license.BLID,
					RejectReason: this.RejectReasonLicense
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.RejectReasonLicense = ''
					this.licenseGetAllLicense()
					this.$parent.baOrganizationList()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "营业执照驳回结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			async licenseRejectBusinessPermission() {
				let {
					code,
					data,
					message
				} = await LicenseRejectBusinessPermission({
					bpid: this.permission.BPID,
					RejectReason: this.RejectReasonPermission
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.RejectReasonPermission = ''
					this.licenseGetAllLicense()
					this.$parent.baOrganizationList()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "医疗器械经营许可证驳回结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			async licenseRejectBusinessRecord() {
				let {
					code,
					data,
					message
				} = await LicenseRejectBusinessRecord({
					brid: this.record.BRID,
					RejectReason: this.RejectReasonRecord
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.RejectReasonRecord = ''
					this.licenseGetAllLicense()
					this.$parent.baOrganizationList()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "第二类医疗器械备案凭证驳回结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			async licenseVerifyLicense() {
				let BLID = ''
				let BPID = ''
				let BRID = ''
				//console.log(this.license);
				if (this.license) {
					BLID = this.license.BLID
				}
				if (this.permission) {
					BPID = this.permission.BPID
				}
				if (this.record) {
					BRID = this.record.BRID
				}
				let {
					code,
					data,
					message
				} = await LicenseVerifyLicense({
					blid: BLID,
					bpid: BPID,
					brid: BRID,
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.$parent.baOrganizationList()
					this.licenseGetAllLicense()
				} else if (code == 1 || code == 2) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "全部审核结果"
				} else {
					this.$message({
						type: "warning",
						message: message
					})
				}
			},
			// 营业执照驳回明细接口
			async licenseGetBusinessLicense() {
				let {
					code,
					data,
					message
				} = await LicenseGetBusinessLicense({
					ID: this.getID
				})
				if (code == 0) {
					this.BusdetailsTableData = null
					this.RedetailsTableData = null
					this.BLdetailsTableData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 医疗器械经营许可证驳回明细接口
			async licenseGetBusinessPermission() {
				let {
					code,
					data,
					message
				} = await LicenseGetBusinessPermission({
					ID: this.getID
				})
				if (code == 0) {
					this.BLdetailsTableData = null
					this.RedetailsTableData = null
					this.BusdetailsTableData = data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
			},
			// 第二类医疗器械备案凭证驳回明细接口
			async licenseGetBusinessRecord() {
				let {
					code,
					data,
					message
				} = await LicenseGetBusinessRecord({
					ID: this.getID
				})
				if (code == 0) {
					if (code == 0) {
						this.BLdetailsTableData = null
						this.BusdetailsTableData = null
						this.RedetailsTableData = data
					} else {
						this.$message({
							type: 'warning',
							message: message
						})
					}

				}
			},
			rejectdonRowClick(val) {
				//console.log(val);
				this.getID = val.ID
				this.detailsTitle = val.LicenseType
				if (val.LicenseType == "营业执照") {
					this.licenseGetBusinessLicense()
				}
				if (val.LicenseType == "医疗器械经营许可证") {
					this.licenseGetBusinessPermission()
				}
				if (val.LicenseType == "第二类医疗器械备案凭证") {
					this.licenseGetBusinessRecord()
				}
			},
			rejecthandleCurrentChange(pageindex) {
				this.Rejectpageindex = pageindex
				this.licenseGetRejectLicense()
			},
			rejecthandleSizeChange(paegSzie) {
				this.RejectpageSize = paegSzie
				this.licenseGetRejectLicense()
			},
			businessLicense() {
				this.licenseBHdialogVisibles = true
			},
			medicalEquipment() {
				this.permissionBHdialogVisibles = true
			},
			CLLMDFCR() {
				this.recordBHdialogVisibles = true
			},
			AllReview() {
				this.licenseVerifyLicense()
			},
			cancelU8() {
				this.dialogVisiblesU8 = false
			},
			dialogOKeditU8() {
				this.dialogVisiblesU8 = false
			},
			cancelU8d() {
				this.dialogVisiblesU8d = false
			},
			dialogOKeditU8d() {
				this.dialogVisiblesU8d = false
			},
			handleSelectionChange(val) {
				this.U8IDsData = val
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			LicenseRLookcancel() {
				this.LicenseRLookdialogVisibles = false
			},
			LicenseRLookdialogOK() {
				this.LicenseRLookdialogVisibles = false
			},
			licenseBHcancel() {
				this.licenseBHdialogVisibles = false
			},
			licenseBHdialogOK() {
				this.licenseRejectBusinessLicense()
				this.licenseBHdialogVisibles = false
			},
			permissionBHcancel() {
				this.permissionBHdialogVisibles = false
			},
			permissionBHdialogOK() {
				this.licenseRejectBusinessPermission()
				this.permissionBHdialogVisibles = false
			},
			recordBHcancel() {
				this.recordBHdialogVisibles = false
			},
			recordBHdialogOK() {
				this.licenseRejectBusinessRecord()
				this.recordBHdialogVisibles = false
			},
			rejectcancel() {
				this.rejectdialogVisibles = false
			},
			rejectdialogOK() {
				this.rejectdialogVisibles = false
			}

		},
		watch: {
			handler: {

			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}

	.Code {
		width: 100%;
	}

	.type {
		width: 98.6%;
		border: 1px solid #e6e6e6;
		font-size: 17px;
		color: #333333;
		font-weight: 500;
		padding: 10px 10px 10px 0;
		margin: 0 auto;

		.type-top {
			width: 100%;
			border-bottom: 1px solid #e6e6e6;
			font-weight: bold;
			color: #333333;
			font-size: 14px;
			text-indent: 16px;
			line-height: 16px;
			padding-bottom: 10px;

			.type-top-left {
				width: 3px;
				height: 16px;
				display: inline-block;
				background-color: #e71d43;
				float: left;
			}
		}

		.type-text {
			margin-top: 12px;
		}

		.CodeText {
			display: inline-block;
			width: 430px;
			margin-left: 30px;
			font-size: 14px;
			font-weight: 500;
			// border: 1px solid red;
			color: #999999;
			margin-top: 12px;

			.imgBox {
				display: inline-block;
				width: 96px;
				height: 96px;
				border: 1px solid #e6e6e6;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}

			span {
				color: #333333;
				font-weight: 500;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}
		}
	}

	.LicenseRfrom {
		width: 100%;
		height: 500px;
		overflow: scroll;
	}

	.detailedCss {
		min-width: 100px;
		max-width: 200px;
		height: 32px;
		background-color: #fce8ec;
		border: 1px solid #e71d43;
		color: #e71d43;
		font-size: 14px;
		text-align: center;
		line-height: 32px;
		margin: 10px 10px 10px 0;
	}
</style>